import { Workspace } from './Workspace';

export class GetWorkspacesParams {
  public userName: string;
  public forceRefresh: boolean;

  constructor(userName: string, forceRefresh: boolean = false){
    this.userName = userName;
    this.forceRefresh = forceRefresh;
  }
}

export class AddWorkspacesParams {
  public key: string;
  public workspaces: Workspace[];

  constructor(key: string, workspaces: Workspace[]){
    this.key = key;
    this.workspaces = workspaces;
  }
}